/**
 * Music mute button
 */
export default class OMT_UI_MusicButton extends G.Button {
    /**
     * constructor
     */
    constructor() {
        super(0, 0, 'small_button_yellow', () => { this._toggleMusic(); });
        this._icon = G.makeImage(0, 0, 'music_on_icon', [0.5, 0.5]);
        this.addChild(this._icon);
        this._updateIconTexture();
    }

    /**
     * update the icon texture based on mute state
     */
    _updateIconTexture() {
        const musicEnabled = G.soundManager.getMusicEnabled();
        this._icon.changeTexture(musicEnabled ? 'music_on_icon' : 'music_off_icon');
    }

    /**
     * toggle the mute state
     */
    _toggleMusic() {
        const state = !G.soundManager.getMusicEnabled();
        G.soundManager.setMusicEnabled(G.MuteReason.UserChoice, state);
        this._updateIconTexture();
        G.saveState.data.mute = !state;
        G.saveState.save();

        if (!G.music.isPlaying && !G.saveState.data.mute) {
            G.music.play('', 0, 1, true);
        }

        OMT.platformTracking.logEvent(OMT.platformTracking.Events.Music, 1, {
            status: state ? 1 : 0,
        });
    }
}